import { Outlet, createFileRoute } from '@tanstack/react-router';
import { PlainHeader } from './_embaUserLayout/-components/PlainHeader';
import styles from './gloplaUserLayout.module.scss';

export const Route = createFileRoute('/_gloplaUserLayout')({
  component: LayoutComponent,
});

function LayoutComponent() {
  return (
    <div className={styles.gloplaUserLayout}>
      <PlainHeader />
      <Outlet />
    </div>
  );
}
